<template>
  <div class="dataBox">
    <span>核实成功，恭喜你成为广东省仪器仪表协会正式会员</span>
  </div>
</template>

<script>
export default {
  name: 'processPaysuccess'
}
</script>

<style scoped>
  .dataBox{
    padding-top: 180px;
  }
  .dataBox span{
    font-size: 18px;
    font-weight: 600;
    color: #1c7430;
  }
</style>



// WEBPACK FOOTER //
// src/components/joinprocess/processSuccess.vue